import AboutHero from '@/components/About/AboutHero';
import AboutShowcase from '@/components/About/AboutShowcase';
import AboutCTA from '@/components/About/AboutCTA';
import AboutMissionVision from '@/components/About/AboutMissionVision';
import AboutTeam from '@/components/About/AboutTeam';
import SecRegistered from '@/components/Common/SecRegistered';

export default function About() {
  return (
    <>
      <AboutHero />
      <AboutShowcase />
      <AboutCTA />
      <SecRegistered />
      <AboutMissionVision />
      <AboutTeam />
    </>
  );
}
